import React, { useDebugValue, useEffect, useState } from 'react'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import { Button, Col, Row, FormGroup, Label, Input } from 'reactstrap'
import * as Yup from 'yup'
import { useNavigate, useParams } from 'react-router-dom'
import Switch from "react-switch";
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux'
import { addCatalogItem, getSolutions, updateCatalogItem } from 'store/actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import Breadcrumb from 'components/Common/Breadcrumb2'
import CheckList from 'pages/Checklists/CheckList'
import { showError } from 'helpers/notification_helper'
import { FaFilter } from "react-icons/fa";

const Offsymbol = () => {
  return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 12, color: "#fff", paddingRight: 2 }}></div>;
};

const OnSymbol = () => {
  return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 12, color: "#fff", paddingRight: 2 }}></div>;
};

const CreateOrder = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');

  const [isActive, setIsActive] = useState(true);
  const [stock, setStock] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedSolution, setSelectedSolution] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState()
  const [initialData, setInitialData] = useState(null); // Store the fetched data
  const [base64CatalogueImage, setBase64CatalogueImage] = useState();
   const solutions = useSelector(state=> state.Solution.solutions)

  const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

  if ((!permissions2?.map(item => item?.permissionName)?.includes("Add Catalogues") && !permissions2?.map(item => item?.permissionName)?.includes("Edit Catalogues"))) {
    navigate('/pages-403')
  }

  const fetchDepartments = async () => {
    const response = await axiosInstance.get('', { params: { sp: 'usp_GetDepartments' } });
    setDepartments(response?.data?.Data);
  }

  const fetchCategories = async () => {
    const response = await axiosInstance.get('', { params: { sp: 'usp_GetCatalogueCategories' } });
    setCategories(response?.data?.Data);
  }

  const fetchCatalogItem = async (id) => {
    const response = await axiosInstance.get('', { params: { sp: 'usp_GetCatalogueById', catalogueId: id } });
    setInitialData(response?.data?.Data?.[0]);
    setIsActive(response?.data?.Data?.[0]?.IsActive);
    setStock(response?.data?.Data?.[0]?.StockAvailable);
  }

  useEffect(() => {
    fetchDepartments();
    fetchCategories();
    if (id) {
      fetchCatalogItem(id);
    }
  }, [id]);

  useEffect(() => {
    if (initialData) {
      setIsActive(initialData?.isActive)
      setStock(initialData?.stockAvailable);
      setSelectedCategory(initialData?.categoryId);
      setSelectedDepartment(initialData?.departmentId);
      setBase64CatalogueImage(initialData?.image);
      setSelectedSolution(initialData?.solutionId)
    }
  }, [initialData])

  useEffect(()=>{
    dispatch(getSolutions())
  },[])


  const validationSchema = Yup.object({
    catalogueName: Yup.string().required('Catalogue Name is required'),
    department: Yup.string().required('Department is required'),
    category: Yup.string().required('Category is required'),
    itemDescription: Yup.string().required('Item Description is required'),
    estimatedInstallationTime: Yup.number().required('Estimated Installation Time is required'),
    isActive: Yup.bool().required('Active status is required'),
    stockAvailable: Yup.bool().required('Stock availability is required'),
    sku: Yup.string().required("Sku is required"),
    model: Yup.string().required("Model is required"),
    surveyTime: Yup.string().required("Survey time is required"),
    catalogueImage: Yup.string().required("Catalogue image is required"),
    solution: Yup.string().required("Solution is required")
  });

  const departmentOptions = departments?.map(item => ({ value: item?.departmentId, label: item?.departmentName }));
  const categoryOptions = categories?.map(item => ({ value: item?.categoryId, label: item?.categoryName }));
  const solutionOptions = [
        { value: 'iot', label: 'IOT' },
        { value: '5g', label: '5G' },
    ];

  // const handleCatalogueFileChange = (e, setFieldValue) => {
  //   const file = e.target.files[0];

  //   if (file) {
  //     if (file.type.startsWith('image/')) { // Accept only images
  //       const reader = new FileReader();

  //       reader.onload = () => {
  //         const base64Image = reader.result;
  //         setFieldValue('catalogueImage', base64Image);
  //         setBase64CatalogueImage(base64Image);
  //       };

  //       reader.readAsDataURL(file);
  //     } else {
  //       showError('Please upload a valid image file');
  //     }
  //   }
  // };

  const handleCatalogueFileChange = (e, setFieldValue) => {
    const file = e.target.files[0];
  
    if (file) {
      const allowedTypes = ['image/jpeg', 'image/png']; // ONLY allow jpg and png
  
      if (allowedTypes.includes(file.type)) {
        const reader = new FileReader();
  
        reader.onload = () => {
          const base64Image = reader.result;
          setFieldValue('catalogueImage', base64Image);
          setBase64CatalogueImage(base64Image);
        };
  
        reader.readAsDataURL(file);
      } else {
        showError('Please upload a JPG or PNG image only');

        e.target.value = '';
        setFieldValue('catalogueImage', '');
      }
    }
  };
  

  return (
    <div className='page-content mt-2'>
      <div className='d-flex justify-content-between align-items-center mx-4'>
        <Breadcrumb title={id ? "Edit Catalogue" : "Create Catalogue"} breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Catalogues", link: '/catalogues' }, { title: `${id ? "Edit Catalogue" : "Create Catalogue"}`, link: '#' }]} />
        <Button className='text-white bg-primary' onClick={() => navigate('/catalogues')}>
          Back
        </Button>
      </div>

      <Formik
        enableReinitialize={true}
        initialValues={{
          catalogueName: initialData?.itemName || '',
          department: initialData?.departmentId || '',
          category: initialData?.categoryId || '',
          itemDescription: initialData?.itemDescription || '',
          estimatedInstallationTime: initialData?.estimatedInstallTimeInMins || '',
          isActive: initialData?.isActive || false,
          stockAvailable: initialData?.stockAvailable || false,
          isSerialNumberRequired: initialData?.isSerialNumberRequired || false,
          sku: initialData?.sku || "",
          model: initialData?.model || "",
          surveyTime: initialData?.surveyTime || "",
          catalogueImage: initialData?.image || "",
          solution:initialData?.solutionId

        }}
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm }) => {
          if (id) {
            const response = await dispatch(
              updateCatalogItem({
                sp: 'usp_UpdateCatalogue',
                catalogueId: Number(id),
                SolutionId: values?.solution,
                DepartmentId: values?.department,
                CategoryId: values?.category,
                itemName: values?.catalogueName,
                itemDescription: values?.itemDescription,
                EstimatedInstallTimeInMins: values?.estimatedInstallationTime,
                IsActive: values?.isActive,
                isSerialNumberRequired: values?.isSerialNumberRequired,
                StockAvailable: values?.stockAvailable,
                SKU: values?.sku,
                model: values?.model,
                surveyTime: values?.surveyTime,
                catalogueImage: base64CatalogueImage ? base64CatalogueImage : initialData?.image || ""
              }, navigate)
            );

          } else {
            // Otherwise, dispatch add action
            dispatch(
              addCatalogItem({
                sp: 'usp_InsertCatalogue',
                SolutionId: selectedSolution,
                DepartmentId: values?.department,
                CategoryId: values?.category,
                ItemName: values?.catalogueName,
                ItemDescription: values?.itemDescription,
                EstimatedInstallTimeInMins: values?.estimatedInstallationTime,
                IsActive: values?.isActive,
                StockAvailable: values?.stockAvailable,
                isSerialNumberRequired: values?.isSerialNumberRequired,
                SKU: values?.sku,
                model: values?.model,
                surveyTime: values?.surveyTime,
                catalogueImage: base64CatalogueImage
              }, navigate, resetForm)
            );
          }
        }}
      >
        {({ values, setFieldValue }) => (
          <Form className='bg-white py-3' style={{ borderRadius: "8px" }}>
            <Row className='mx-3'>
              <Col md={6} xs={12}>
                <FormGroup>
                  <Label for="catalogueName">Catalogue Name</Label> <span className='text-danger'>*</span>
                  <Field
                    name="catalogueName"
                    className="form-control form-control-md"
                    type="text"
                    placeholder="Enter catalogue name"
                    style={{ height: "38px", border: "1px solid lightgray" }}
                  />
                  <ErrorMessage name="catalogueName" component="div" className="text-danger" />
                </FormGroup>
              </Col>

              <Col md={6} xs={12}>
                <FormGroup>
                  <Label for="department">Department</Label> <span className='text-danger'>*</span>
                  <Select
                    name="department"
                    options={departmentOptions}
                    onChange={option => { setFieldValue("department", option.value); setSelectedDepartment(option?.value) }}
                    placeholder="Select department"
                    value={departmentOptions?.find(option => option.value == selectedDepartment)}
                  />
                  <ErrorMessage name="department" component="div" className="text-danger" />
                </FormGroup>
              </Col>

              <Col md={6} xs={12}>
                <FormGroup>
                  <Label for="category">Category</Label> <span className='text-danger'>*</span>
                  <Select
                    name="category"
                    options={categoryOptions}
                    onChange={option => { setFieldValue("category", option.value); setSelectedCategory(option?.value) }}
                    placeholder="Select category"
                    value={categoryOptions?.find(option => option.value == selectedCategory)}
                  />
                  <ErrorMessage name="category" component="div" className="text-danger" />
                </FormGroup>
              </Col>

              <Col md={6} xs={12} className="d-flex justify-content-start gap-3 align-items-center">
                <div className="mr-2 d-flex gap-2 align-items-center mt-2">
                  <Label for="isActive" className='mb-0'>Is Active</Label>
                  <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    onColor="#626ed4"
                    onChange={() => setFieldValue('isActive', !values?.isActive)}
                    checked={values?.isActive}
                    width={40}
                    height={20}
                    handleDiameter={18}
                  />
                </div>
                <div className='d-flex gap-2 align-items-center mt-2'>
                  <Label for="stockAvailable" className='mb-0'>Stock Available</Label>
                  <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    onColor="#626ed4"
                    onChange={() => setFieldValue('stockAvailable', !values?.stockAvailable)}
                    checked={values?.stockAvailable}
                    width={40}
                    height={20}
                    handleDiameter={18}
                  />
                </div>
              </Col>

              <Col md={6} xs={12}>
                <FormGroup>
                  <Label for="estimatedInstallationTime">Estimated Installation Time (in minutes)</Label> <span className='text-danger'>*</span>
                  <Field
                    name="estimatedInstallationTime"
                    className="form-control form-control-md"
                    type="number"
                    placeholder="Enter estimated installation time in minutes"
                    style={{ height: "38px", border: "1px solid lightgray" }}
                  />
                  <ErrorMessage name="estimatedInstallationTime" component="div" className="text-danger" />
                </FormGroup>
              </Col>

              <Col md={6} xs={12}>
                <FormGroup>
                  <Label for="sureveyTime">SurveyTime (in minutes)</Label> <span className='text-danger'>*</span>
                  <Field
                    name="surveyTime"
                    className="form-control form-control-md"
                    type="number"
                    placeholder="Enter estimated survey time in minutes"
                    style={{ height: "38px", border: "1px solid lightgray" }}
                  />
                  <ErrorMessage name="surveyTime" component="div" className="text-danger" />
                </FormGroup>
              </Col>

              <Col md={6} xs={12}>
                <FormGroup>
                  <Label for="model">Model</Label> <span className='text-danger'>*</span>
                  <Field
                    name="model"
                    className="form-control form-control-md"
                    type="text"
                    placeholder="Enter model"
                    style={{ height: "38px", border: "1px solid lightgray" }}
                  />
                  <ErrorMessage name="model" component="div" className="text-danger" />
                </FormGroup>
              </Col>

              <Col md={6} xs={12}>
                <FormGroup>
                  <Label for="sku">SKU</Label> <span className='text-danger'>*</span>
                  <Field
                    name="sku"
                    type="text"
                    className="form-control form-control-md"
                    placeholder="Enter sku"
                    style={{ height: "38px", border: "1px solid lightgray" }}
                  />
                  <ErrorMessage name="sku" component="div" className="text-danger" />
                </FormGroup>
              </Col>

              <Col md={6} xs={12}>
                <FormGroup>
                  <Label>Catalogue Image</Label> <span className='text-danger'>*</span>
                  <Input
                    type="file"
                    name="catalogueImage"
                    accept="image/*"
                    onChange={(event) => handleCatalogueFileChange(event, setFieldValue)}
                    style={{ height: "38px", border: "1px solid lightgray" }}
                  />
                  <ErrorMessage name="catalogueImage" component="div" className="text-danger" />
                </FormGroup>
              </Col>

              <Col md={6} xs={12} className="d-flex justify-content-start gap-3 align-items-center">
                <div className='d-flex gap-2 align-items-center mt-3'>
                  <Label for="isSerialNumberRequired" className='mb-0'>Is Serial Number Required</Label>
                  <Switch
                    uncheckedIcon={<Offsymbol />}
                    checkedIcon={<OnSymbol />}
                    onColor="#626ed4"
                    onChange={() => setFieldValue('isSerialNumberRequired', !values?.isSerialNumberRequired)}
                    checked={values?.isSerialNumberRequired}
                    width={40}
                    height={20}
                    handleDiameter={18}
                  />
                </div>
              </Col>

               {/* solution */}
              <Col md={6} xs={12}>
                <FormGroup>
                  <Label for="solution">Solution</Label> <span className='text-danger'>*</span>
                  <Select
                    name="solution"
                    options={solutions?.map(item=>({label:item?.solutionName,value:item?.solutionId}))}
                    onChange={option => { setSelectedSolution(option.value); setFieldValue('solution',option.value)}}
                    placeholder="Select solution"
                    value={solutions?.map(item=>({label:item?.solutionName,value:item?.solutionId}))?.find(option => option.value == selectedSolution)}
                    isClearable={true}
                  />
                  <ErrorMessage name="solution" component="div" className="text-danger" />
                </FormGroup>
              </Col>

              <Col md={12} xs={12}>
                <FormGroup>
                  <Label for="itemDescription">Item Description</Label> <span className='text-danger'>*</span>
                  <Field
                    name="itemDescription"
                    as="textarea"
                    className="form-control form-control-md"
                    placeholder="Enter item description"
                    rows="4"
                    style={{ border: "1px solid lightgray" }}
                  />
                  <ErrorMessage name="itemDescription" component="div" className="text-danger" />
                </FormGroup>
              </Col>

              <Col md={6} xs={12}>
                <Button color="primary" type="submit" className="btn-md">
                  {id ? 'Update' : 'Submit'}
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
      <div className='bg-white rounded-3 p-3 mt-3'>
        {id && <CheckList id={id} />}
      </div>
    </div>
  )
}

export default CreateOrder;
